// GENERATED FILE - DO NOT EDIT BY HAND.
// Source: data/YCP_Wage_Rates.csv + data/YCP_Wage_BargainingUnits.csv
// Regenerate: node scripts/gen-wage-rates.js
//
// ONE master wage table for every recognized bargaining unit (all railroads / agreements /
// committees), each with its own references. Rates are time-aware and scope-aware and keyed
// on the BARGAINING UNIT (carrier_property). OT and premiums DERIVE (base x 1.5) - never stored.
// Blank end_date = last KNOWN rate; rate_status distinguishes "sourced" from "projected_gwi_only".
// never stored on the unit row (a fact in two places is a defect - resolve to one source).
//
// The tables are installation content since ruling 321 slice 3c (task list section 731):
// installations\smart-td\content\wageTables.js, projected to src\data\wageTables.js. This file is the code.

import { WAGE_RATES, WAGE_BARGAINING_UNITS } from './wageTables';
export { WAGE_RATES, WAGE_BARGAINING_UNITS };

// resolveWageRate(carrierProperty, positionClass, scope, asOfDate)
// -> the effective straight-time base for that bargaining unit + position + scope, as of a date.
export function resolveWageRate(carrierProperty, positionClass, scope, asOfDate) {
  const today = asOfDate || new Date().toISOString().slice(0, 10);
  const want = scope || "";
  const cand = WAGE_RATES.filter(function (r) {
    return r.carrier_property === carrierProperty
      && r.position_class === positionClass
      && (r.scope === want || (!r.scope && !want))
      && r.effective_date <= today
      && (r.end_date === "" || today < r.end_date);
  }).sort(function (a, b) { return a.effective_date < b.effective_date ? 1 : a.effective_date > b.effective_date ? -1 : 0; });
  if (!cand.length) return { found: false, carrierProperty: carrierProperty, positionClass: positionClass, scope: want, note: "No sourced rate for this bargaining unit/position/scope as of " + today + "." };
  const r = cand[0];
  const base = parseFloat(r.base_hourly);
  return {
    found: true, carrierProperty: r.carrier_property, positionClass: r.position_class, scope: r.scope,
    baseHourly: base, overtimeHourly: Math.round(base * 1.5 * 100) / 100,
    effectiveDate: r.effective_date, isCurrent: r.end_date === "", sourceDoc: r.source_doc, notes: r.notes,
    rateStatus: r.rate_status || "sourced", projected: !!r.rate_status && r.rate_status !== "sourced",
  };
}

// wageUnitCoverage() -> each recognized unit joined to whether it has ANY sourced rate rows.
// A rate row belongs to a unit when carrier_property matches AND the rate craft is the unit
// craft or a sub-position of it (e.g. "Assistant Yardmaster" rolls up to the "Yardmaster" unit).
// status: "seeded" = >=1 sourced rate on file (may be historical / not current); "pending" = none yet.
export function wageUnitCoverage() {
  return WAGE_BARGAINING_UNITS.map(function (u) {
    const mine = WAGE_RATES.filter(function (r) {
      return r.carrier_property === u.carrier_property
        && (r.craft === u.craft || r.craft.indexOf(u.craft) !== -1);
    });
    const scopes = [];
    mine.forEach(function (r) { if (scopes.indexOf(r.scope) === -1) scopes.push(r.scope); });
    const dates = mine.map(function (r) { return r.effective_date; }).filter(Boolean).sort();
    return {
      carrierProperty: u.carrier_property, craft: u.craft, committee: u.committee,
      agreement: u.agreement, notes: u.notes,
      status: mine.length ? "seeded" : "pending",
      rateRows: mine.length, scopesSourced: scopes,
      earliestEffective: dates.length ? dates[0] : null,
    };
  });
}
